import { supabase } from '../lib/supabase';


// Convert database snake_case to React camelCase
const convertToServicioCorteObject = (dbServicio) => {
  if (!dbServicio) return null;
  
  return {
    id: dbServicio?.id,
    fecha: dbServicio?.fecha,
    horaInicio: dbServicio?.hora_inicio,
    horaFin: dbServicio?.hora_fin,
    cliente: dbServicio?.cliente,
    ubicacion: dbServicio?.ubicacion,
    tipoServicio: dbServicio?.tipo_servicio,
    empleadoId: dbServicio?.empleado_id,
    numPiezas: dbServicio?.num_piezas,
    descripcionPiezas: dbServicio?.descripcion_piezas,
    precioServicio: dbServicio?.precio_servicio,
    gastos: dbServicio?.gastos,
    observaciones: dbServicio?.observaciones,
    estado: dbServicio?.estado,
    createdAt: dbServicio?.created_at
  };
};

// Convert React camelCase to database snake_case
const convertToDbObject = (servicio) => {
  return {
    fecha: servicio?.fecha,
    hora_inicio: servicio?.horaInicio || null,
    hora_fin: servicio?.horaFin || null,
    cliente: servicio?.cliente,
    ubicacion: servicio?.ubicacion,
    tipo_servicio: servicio?.tipoServicio,
    empleado_id: servicio?.empleadoId || null,
    num_piezas: servicio?.numPiezas,
    descripcion_piezas: servicio?.descripcionPiezas,
    precio_servicio: servicio?.precioServicio === '' || servicio?.precioServicio === null || servicio?.precioServicio === undefined ? null : servicio?.precioServicio,
    gastos: servicio?.gastos === '' || servicio?.gastos === null || servicio?.gastos === undefined ? null : servicio?.gastos,
    observaciones: servicio?.observaciones,
    estado: servicio?.estado
  };
};

export const serviciosCorteService = {
  // Get all servicios_corte
  async getAll() {
    const { data, error } = await supabase?.from('servicios_corte')?.select('*')?.order('fecha', { ascending: false })?.order('hora_inicio', { ascending: false });
    
    if (error) throw error;
    
    return data?.map(convertToServicioCorteObject);
  },

  // Get servicio by ID
  async getById(id) {
    const { data, error } = await supabase?.from('servicios_corte')?.select('*')?.eq('id', id)?.single();
    
    if (error) throw error;
    
    return convertToServicioCorteObject(data);
  },

  // Create new servicio
  async create(servicio) {
    const dbServicio = convertToDbObject(servicio);
    
    const { data, error } = await supabase?.from('servicios_corte')?.insert(dbServicio)?.select()?.single();
    
    if (error) throw error;
    
    return convertToServicioCorteObject(data);
  },

  // Update servicio
  async update(id, servicio) {
    const dbServicio = convertToDbObject(servicio);
    
    const { data, error } = await supabase?.from('servicios_corte')?.update(dbServicio)?.eq('id', id)?.select()?.single();
    
    if (error) throw error;
    
    return convertToServicioCorteObject(data);
  },

  // Delete servicio
  async delete(id) {
    const { error } = await supabase?.from('servicios_corte')?.delete()?.eq('id', id);
    
    if (error) throw error;
    
    return true;
  },

  // Get servicios by date range
  async getByDateRange(startDate, endDate) {
    const { data, error } = await supabase?.from('servicios_corte')?.select('*')?.gte('fecha', startDate)?.lte('fecha', endDate)?.order('fecha', { ascending: true })?.order('hora_inicio', { ascending: true });
    
    if (error) throw error;
    
    return data?.map(convertToServicioCorteObject);
  },

  // Get servicios by employee
  async getByEmpleado(empleadoId) {
    const { data, error } = await supabase?.from('servicios_corte')?.select('*')?.eq('empleado_id', empleadoId)?.order('fecha', { ascending: false });
    
    if (error) throw error;
    
    return data?.map(convertToServicioCorteObject);
  },

  // Get servicios by estado
  async getByEstado(estado) {
    const { data, error } = await supabase?.from('servicios_corte')?.select('*')?.eq('estado', estado)?.order('fecha', { ascending: false });
    
    if (error) throw error;
    
    return data?.map(convertToServicioCorteObject);
  }
};